export type WorkspacePage =
  | 'landing'
  | 'dashboard'
  | 'lyrics'
  | 'cast-assets'
  | 'production';

export interface AppRoute {
  page: WorkspacePage;
  projectId?: string;
  step?: string;
}


export function routeForPage(
  page: string,
  projectId?: string,
  step?: string,
): AppRoute {
  if (projectId) return {page: 'production', projectId, step: step || 'project'};
  if (page === 'landing' || page === 'lyrics' || page === 'cast-assets') return {page};
  return {page: 'dashboard'};
}


export function routePath(route: AppRoute): string {
  if (route.page === 'production' && route.projectId) {
    const project = encodeURIComponent(route.projectId);
    const step = encodeURIComponent(route.step || 'project');
    return `#/productions/${project}/${step}`;
  }
  if (route.page === 'production') return '#/productions';
  const names: Record<Exclude<WorkspacePage, 'production'>, string> = {
    landing: 'showcase',
    dashboard: 'projects',
    lyrics: 'productions',
    'cast-assets': 'cast-assets',
  };
  return `#/${names[route.page]}`;
}


export function writeRoute(route: AppRoute, replace = false): void {
  const next = routePath(route);
  if (window.location.hash === next) return;
  window.history[replace ? 'replaceState' : 'pushState']({}, '', next);
}


export function readRoute(hash = window.location.hash): AppRoute | null {
  // Preserve links already published by the React routes; one Studio owns them.
  if (!hash && window.location.pathname !== '/') {
    const path = window.location.pathname.split('/').filter(Boolean).map(decodeURIComponent);
    if (path[0] === 'productions' && path[1] === 'lyric' && path[2]) {
      return {page: 'production', projectId: path[2], step: path[3] || 'project'};
    }
    if (path[0] === 'productions') return {page: 'lyrics'};
    if (path[0] === 'dashboard') return {page: 'dashboard'};
    if (path[0] === 'cast-assets') return {page: 'cast-assets'};
  }
  const value = hash.replace(/^#\/?/, '');
  const parts = value.split('/').filter(Boolean).map(decodeURIComponent);
  if (parts[0] === 'productions' && parts[1]) {
    return {page: 'production', projectId: parts[1], step: parts[2] || 'project'};
  }
  if (parts[0] === 'showcase') return {page: 'landing'};
  if (parts[0] === 'cast-assets') return {page: 'cast-assets'};
  if (parts[0] === 'productions') return {page: 'lyrics'};
  if (parts[0] === 'projects') return {page: 'dashboard'};
  return null;
}
